export default __webpack_public_path__ + "static/media/join-battle-disabled.114ffb7d.svg";